import {
	httpPost
} from "../../config/request.js"
// 获取结算商品数据
export function getOrderInfoByShoppingCartApi(params) {
	return httpPost('/order/orderInfo/getOrderInfoByShoppingCart', params)
}
// 保存订单
export function saveOrderInfoApi(params) {
	return httpPost('/order/orderInfo/saveOrderInfo', params)
}
// 查询订单信息
export function getOrderInfoBoByMembIdAndIdApi(params) {
	return httpPost('/order/orderInfo/getOrderInfoBoByMembIdAndId', params)
}
// 订单超时关闭
export function closeOrderByIdApi(params) {
	return httpPost('/order/orderInfo/closeOrderById', params)
}

export function manualCloseOrderByIdApi(params) {
	return httpPost('/order/orderInfo/manualCloseOrderById', params)
}

export function receiveDealOrderByIdApi(params) {
	return httpPost('/order/orderInfo/receiveDealOrderById', params)
}
// 查询订单状态
export function selOrderInfoStateByIdApi(params) {
	return httpPost('/order/orderInfo/selOrderInfoStateById', params)
}

export function getMembAccountByMembIdAndCurrencyIdApi(params) {
	return httpPost('/memb/membAccount/getMembAccountByMembIdAndCurrencyId', params)
}

export function getBaseSystemSetInfoByPlatIdApi(params) {
	return httpPost('/base/baseRuleSet/getBaseSystemSetInfoByPlatId', params)
}

export function selChiefNameAndLaveInteralApi(params) {
	return httpPost('/memb/membAccountSummary/selChiefNameAndLaveInteral', params)
}

export function getEstimatedScoreApi(params) {
	return httpPost('/order/orderInfo/getEstimatedScore', params)
}
// 订单支付
export function orderPaymentApi(params) {
	return httpPost('/order/orderInfo/orderPayment', params)
}

export function updateOrderInfoApi(params) {
	return httpPost('/order/orderInfo/updateOrderInfo', params)
}

export function selectSysParamPlatStoreSetByPlatIdApi(params) {
	return httpPost('/base/SysParamPlatStoreSet/selectSysParamPlatStoreSetByPlatId', params)
}
// 更新订单使用各个账户金额
export function updateOrderInfoEveryMoneyApi(params) {
	return httpPost('/order/orderInfo/updateOrderInfoEveryMoney', params)
}

export function countOrderInfo(params) {
	return httpPost('/order/orderInfo/countOrderInfo', params)
}

export function getOrderInfoByMembIdApi(params) {
	return httpPost('/order/orderInfo/getOrderInfoByMembId', params)
}

export function settlementDealOrderByIdApi(params) {
	return httpPost('/order/orderInfo/settlementDealOrderById', params)
}

export function selOrderInfoStateByIdNewApi(params) {
	return httpPost('/order/orderInfo/selOrderInfoStateByIdNew', params)
}

export function actCouponOrderPaymentApi(params) {
	return httpPost('/order/orderInfo/actCouponOrderPayment', params)
}

export function integralOrderPaymentApi(params) {
	return httpPost('/order/orderInfo/integralOrderPayment', params)
}

export function payUnifiedorderApi(params) {
	return httpPost('/order/sxy/payUnifiedorder', params)
}


//二维码生成
export function createWxCode(params) {
	return httpPost('/order/wx/create_wx_code', params)
}
// 清除订单支付锁
export function deleteOrderPayApi(params) {
	return httpPost('/order/orderInfo/deleteOrderPay', params)
}